import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInformativos } from '../../../context/InformativosContext';
import api from '../../../services/api';
import './InformativosSidebar.css';

export default function InformativosSidebar({ onClose }) {
  const [unviewedInformativos, setUnviewedInformativos] = useState([]);
  const [loading, setLoading] = useState(false);
  const { lastUpdate } = useInformativos();
  const navigate = useNavigate();

  useEffect(() => {
    fetchUnviewedInformativos();
  }, []);

  // Atualiza a lista quando lastUpdate muda (qualquer marca/desmarca de informativo)
  useEffect(() => {
    fetchUnviewedInformativos();
  }, [lastUpdate]);

  const fetchUnviewedInformativos = async () => {
    setLoading(true);
    try {
      const res = await api.get('/informativos/unviewed');
      setUnviewedInformativos(res.data.informativos);
    } catch (err) {
      console.error('Erro ao buscar informativos não vistos:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAsViewed = async (informativoId) => {
    try {
      await api.post(`/informativos/${informativoId}/view`);
      // Remover da lista local imediatamente
      setUnviewedInformativos(prev => prev.filter(inf => inf.id !== informativoId));
    } catch (err) {
      console.error('Erro ao marcar como visto:', err);
    }
  };

  const handleViewInformativo = (informativo) => {
    // Scroll para o card do informativo na página principal
    const element = document.getElementById(`informativo-card-${informativo.id}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Animar o elemento com pulsação
      element.classList.add('pulse-animation');
      setTimeout(() => element.classList.remove('pulse-animation'), 1500);
    }
  };

  return (
    <div className="informativos-sidebar-overlay open">
      <div className="informativos-sidebar" onClick={e => e.stopPropagation()}>
        <div className="sidebar-header">
          <h3>Informativos Pendentes</h3>
        </div>

        <div className="sidebar-content">
          {loading ? (
            <div className="loading-state">
              <div className="loading-spinner"></div>
              <p>Carregando...</p>
            </div>
          ) : unviewedInformativos.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">✅</div>
              <h4>Todos os informativos foram vistos!</h4>
              <p>Você está em dia com todas as novidades.</p>
            </div>
          ) : (
            <div className="informativos-list">
              {unviewedInformativos.map(informativo => {
                const apiBase = process.env.REACT_APP_URL_BASE || '';
                const apiOrigin = apiBase.replace(/\/api\/?$/i, '').replace(/\/$/, '');
                const imageSrc = informativo.images && informativo.images.length > 0
                  ? `${apiOrigin}/uploads/${informativo.images[0]}`
                  : null;

                return (
                  <div 
                    key={informativo.id} 
                    className="informativo-item"
                    onClick={() => handleViewInformativo(informativo)}
                  >
                    {imageSrc && (
                      <div className="item-thumbnail">
                        {informativo.images[0].toLowerCase().endsWith('.pdf') ? (
                          <div className="pdf-icon-mini">📄</div>
                        ) : (
                          <img src={imageSrc} alt="" className="thumbnail-image" />
                        )}
                      </div>
                    )}
                    <div className="item-content">
                      <h4 className="item-title">{informativo.title}</h4>
                      <p className="item-description">
                        {informativo.description?.substring(0, 80)}
                        {informativo.description?.length > 80 ? '...' : ''}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}